/* eslint-disable */
import * as React from 'react';
//import styled from "styled-components";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
// import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { OUR_GALLERY } from '../../constant/match';
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../../interfaces/redux';
// import AdverticeIndex from './advertice';
interface Iphoto {
    src: string,
    actualWidth: number,
    actualHeight: number,
    width: number,
    height: number,
    title?: string,
    caption?: string
}
const photos: Iphoto[] = [
    {
        src: "assets/gallery-images/image1.jpg",
        actualWidth: 750,
        actualHeight: 498,
        width: 10,
        height: 4,
        title: "LCD Prize",
        caption: "test"
    },
    // {
    //     src: "assets/gallery-images/image34_original.jpg",
    //     width: 4,
    //     height: 3,
    //     title: "LCD Prize",
    //     caption: "test"
    // },
    {
        src: "assets/gallery-images/image2_original.jpg",
        width: 6,
        height: 4,
        actualWidth: 410,
        actualHeight: 230,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image3_original.jpg",
        width: 6,
        height: 4,
        actualWidth: 900,
        actualHeight: 600,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image4.jpg",
        width: 6,
        height: 4,
        actualWidth: 760,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image5.jpg",
        width: 6,
        height: 4,
        actualWidth: 380,
        actualHeight: 360,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image6.jpg",
        width: 4,
        height: 3,
        actualWidth: 760,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image7.jpg",
        width: 3,
        height: 4,
        actualWidth: 380,
        actualHeight: 360,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image8_original.jpg",
        width: 4,
        height: 3,
        actualWidth: 1280,
        actualHeight: 720,
        title: "LCD Prize",
        caption: "test"
    },
    // {
    //     src: "assets/gallery-images/image9_original.jpg",
    //     width: 4,
    //     height: 3,
    //     actualWidth: 1300,
    //     actualHeight: 1050,
    //     title: "LCD Prize",
    //     caption: "test"
    // },
    {
        src: "assets/gallery-images/image10.jpg",
        actualWidth: 380,
        actualHeight: 360,
        width: 4,
        height: 3,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image11.jpg",
        width: 6,
        height: 3,
        actualWidth: 760,
        actualHeight: 570,
        title: "LCD Prize"
    },
    {
        src: "assets/gallery-images/image12_original.jpg",
        width: 6,
        height: 4,
        actualWidth: 640,
        actualHeight: 380,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image13_original.jpeg",
        width: 4,
        height: 3,
        actualWidth: 660,
        actualHeight: 400,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image14.jpg",
        width: 4,
        height: 3,
        actualWidth: 380,
        actualHeight: 360,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image15_original.jpg",
        width: 3,
        height: 3,
        actualWidth: 275,
        actualHeight: 183,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image16_original.jpg",
        width: 4,
        height: 4,
        actualWidth: 294,
        actualHeight: 171,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image17_original.jpg",
        width: 4,
        height: 3,
        actualWidth: 546,
        actualHeight: 350,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image18_original.jpg",
        width: 4,
        height: 3,
        actualWidth: 300,
        actualHeight: 150,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image19.jpg",
        width: 6,
        height: 3,
        actualWidth: 380,
        actualHeight: 360,
        title: "LCD Prize",
        caption: "test"
    },
    // {
    //     src: "assets/gallery-images/image32_original.jpg",
    //     width: 3,
    //     height: 3,
    //     title: "LCD Prize",
    //     caption: "test"
    // },
    {
        src: "assets/gallery-images/image20_original.jpeg",
        width: 10,
        height: 5,
        actualWidth: 680,
        actualHeight: 453,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image21.jpg",
        width: 4,
        height: 3,
        actualWidth: 760,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    // {
    //     src: "assets/gallery-images/image33_original.jpg",
    //     width: 4,
    //     height: 4,
    //     title: "LCD Prize",
    //     caption: "test"
    // },
    {
        src: "assets/gallery-images/image22_original.jpg",
        width: 4,
        height: 3,
        actualWidth: 693,
        actualHeight: 370,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image23.jpg",
        width: 6,
        height: 3,
        actualWidth: 600,
        actualHeight: 374,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image24_original.jpg",
        width: 6,
        height: 3,
        actualWidth: 640,
        actualHeight: 428,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image25_original.jpg",
        width: 6,
        height: 3,
        actualWidth: 546,
        actualHeight: 350,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image26.jpg",
        width: 6,
        height: 3,
        actualWidth: 760,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image27_original.jpg",
        width: 6,
        height: 3,
        actualWidth: 850,
        actualHeight: 478,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image28_original.jpg",
        width: 6,
        height: 3,
        actualWidth: 512,
        actualHeight: 384,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image29_original.jpg",
        width: 6,
        height: 3,
        actualWidth: 460,
        actualHeight: 280,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image30_original.jpg",
        width: 6,
        height: 3,
        actualWidth: 1280,
        actualHeight: 853,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image31_original.jpg",
        width: 6,
        height: 3,
        actualWidth: 380,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image32.jpg",
        width: 6,
        height: 3,
        actualWidth: 360,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image33.jpg",
        width: 6,
        height: 3,
        actualWidth: 360,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image34.jpg",
        width: 6,
        height: 3,
        actualWidth: 360,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    },
    {
        src: "assets/gallery-images/image35.jpg",
        width: 6,
        height: 3,
        actualWidth: 360,
        actualHeight: 570,
        title: "LCD Prize",
        caption: "test"
    }
    // {
    //     src: "assets/gallery-images/image31.jpg",
    //     width: 4,
    //     height: 3,
    //     title: "LCD Prize",
    //     caption: "test"
    // }
];

function GalleryIndex() {
    const [currentImage, setCurrentImage] = React.useState(0);
    const [viewerIsOpen, setViewerIsOpen] = React.useState(false);
    let filteredList: Iphoto[] = [...photos];
    let horizontalList: any[] = []
    let verticalList: any[] = [];
    let widthList: Iphoto[] = [];
    let heightList: Iphoto[] = [];
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLang = globalState?.selectedLang || "";

    const openLightbox = React.useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const removeDuplicate = (a, b) => {
        // A comparer used to determine if two entries are equal.
        const isSameUser = (a, b) => a.actualHeight === b.actualHeight && a.actualWidth === b.actualWidth;

        // Get items that only occur in the left array,
        // using the compareFunction to determine equality.
        const onlyInLeft = (left, right, compareFunction) =>
            left.filter(leftValue =>
                !right.some(rightValue =>
                    compareFunction(leftValue, rightValue)));

        const onlyInA = onlyInLeft(a, b, isSameUser);
        const onlyInB = onlyInLeft(b, a, isSameUser);

        const result = [...onlyInA, ...onlyInB];
        return result;
    }

    React.useEffect(() => {
        const differenceImage = 100;
        function recurse() {
            // function code
            heightList = filteredList.sort((item1: Iphoto, item2: Iphoto) => item2.actualHeight - item1.actualHeight)
            let filterHeightList = heightList.filter((fItem: Iphoto) => heightList[0].actualHeight - fItem.actualHeight < differenceImage)
            if (filterHeightList.length) {
                horizontalList.push(filterHeightList)
            }
            filteredList = removeDuplicate(filteredList, filterHeightList)
            widthList = filteredList.sort((item1: Iphoto, item2: Iphoto) => item2.actualWidth - item1.actualWidth)
            let filterWidthList = widthList.filter((fItem: Iphoto) => widthList[0].actualWidth - fItem.actualWidth < differenceImage)
            if (filterWidthList.length) {
                verticalList.push(filterWidthList)
            }
            filteredList = removeDuplicate(filteredList, filterWidthList)
            if (filteredList.length > 1) {
                recurse();
            }
        }

        recurse();
        horizontalList = horizontalList.sort((item1, item2) => item2.length - item1.length)
        verticalList = verticalList.sort((item1, item2) => item2.length - item1.length)
        console.log("hhello >>>>", horizontalList, verticalList)
    }, [])

    const listItems = photos.map((photo, index) =>
        <div key={index}>
            <img alt="" src={photo.src} />
            {/* <div style="background-image: url(../images/test-background.gif); "></div> */}
            <p className="legend">{photo.caption}</p>
        </div>
    );
    return (
        <React.Fragment>
            <div id="portfolio" className="container text-center no-transition">
                <div className="heading-area mx-570 pt-3 pb-lg-5">
                    <h6 className="sub-title main-color">{OUR_GALLERY[selectedLang]['subtitle']}</h6>
                    <h1 className="title">{OUR_GALLERY[selectedLang]['title']}</h1>
                    {/* <p className="paragraph">There are many variations of passages of Lorem Ipsum available be the majority have
                        suffered alteration in some form.</p> */}
                </div>

                <Gallery margin={10} photos={photos} onClick={openLightbox} />
                {/* {console.log("jjjj", currentImage)} */}
                {/* <ModalGateway>
                {viewerIsOpen ? <Modal onClose={closeLightbox}>
                        <Carousel
                            currentIndex={currentImage}
                            views={photos.map((x: any) => ({
                                ...x,
                                srcset: x.srcSet,
                                caption: x.title
                            }))}
                        >
                        </Carousel>
                    </Modal>: <></>}
            </ModalGateway> */}
            </div>
        </React.Fragment>
    )
}

export default GalleryIndex;
